import moment from 'moment'
moment.locale('es')

export function dateFormat () {
  return function (value, format) {
    if (!value) {
      return 'N/A'
    }
    return moment(value, 'YYYY-MM-DD').format(format)
  }
}

export function currency () {
  return function (value) {
    if (value === undefined) {
      return null
    }

    const result = value.toFixed(0).replace('.', ',')
    return '$ ' + result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
}
